import {
  MultiselectColumnDefinition,
  MultiselectCriteria,
  multiselectFilter,
  MultiselectFilterChangeFunction,
} from "../generic/MultiselectColumnDefinition";

export const PAYMENT_RANK_CRITERIA_KEY = "paymentRank";

type PaymentRank = string;

export function getSortedPaymentRanks<TItemKey extends string>(
  key: TItemKey,
  rows: Array<{
    [key in TItemKey]: PaymentRank;
  }>,
) {
  const values = Array.from(new Set(rows.map((row) => row[key])).values());
  values.sort();

  return values;
}

export const paymentRankFilter = <TItemKey extends string>(key: TItemKey) =>
  multiselectFilter(PAYMENT_RANK_CRITERIA_KEY, key);

export const PaymentRankColumnDefinition = <K extends string>(
  key: K,
  criteria: MultiselectCriteria<typeof PAYMENT_RANK_CRITERIA_KEY, PaymentRank>,
  onFilterChange: MultiselectFilterChangeFunction<typeof PAYMENT_RANK_CRITERIA_KEY, PaymentRank>,
  paymentRanks: PaymentRank[],
) =>
  MultiselectColumnDefinition(
    "Payment Rank",
    key,
    PAYMENT_RANK_CRITERIA_KEY,
    criteria,
    onFilterChange,
    paymentRanks,
    (a) => a,
    (a) => a,
  );
